var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#header[data-v-16a9d103] {\n  background-image: url(" + escape(require("../assets/img/larger-sepia.png")) + ");\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n}\n.level[data-v-16a9d103] {\n  height: 100px;\n}\n.level-item[data-v-16a9d103] {\n flex-shrink: 1;\n  padding: 20px 10px;\n}\n\n\n", ""]);

// exports
